(function ($) {
    function getInt($element, attribute, fallback) {
        var value = parseInt($element.attr(attribute), 10);

        return Number.isNaN(value) ? fallback : value;
    }

    function getBool($element, attribute) {
        return $element.attr(attribute) === '1';
    }

    function getSlideBy($element) {
        return $element.attr('data-slide-by') === 'page' ? 'page' : 1;
    }

    function getNavText() {
        return [
            "<span class='sr-only'>Previous slide</span><i class='icon-angle-left' aria-hidden='true'></i>",
            "<span class='sr-only'>Next slide</span><i class='icon-angle-right' aria-hidden='true'></i>",
        ];
    }

    function cleanDuplicateControls($carousel) {
        $carousel.children('.owl-nav').not(':first').remove();
        $carousel.children('.owl-dots').not(':first').remove();
    }

    function syncCarouselWidth($carousel) {
        var $parent = $carousel.parent();
        var parentWidth = getBool($carousel, 'data-edge-to-edge')
            ? Math.floor(window.innerWidth)
            : Math.floor($parent.innerWidth());

        if (parentWidth > 0) {
            $carousel.css('width', parentWidth + 'px');
        }
    }

    function refreshCarousel($carousel) {
        syncCarouselWidth($carousel);
        $carousel.trigger('refresh.owl.carousel');
        cleanDuplicateControls($carousel);
    }

    function initCarousel(selector, defaults) {
        if (!$.fn.owlCarousel) {
            return;
        }

        $(selector).each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                return;
            }

            var desktopItems = getInt($carousel, 'data-items-desktop', defaults.desktopItems);
            var tabletItems = getInt($carousel, 'data-items-tablet', defaults.tabletItems);
            var mobileItems = getInt($carousel, 'data-items-mobile', defaults.mobileItems);
            var itemCount = getInt($carousel, defaults.countAttribute, 0);
            var hasMultiplePages = itemCount > desktopItems;
            var gap = getInt($carousel, 'data-gap', defaults.gap);
            var arrows = getBool($carousel, 'data-arrows');
            var dots = getBool($carousel, 'data-dots');
            var loop = getBool($carousel, 'data-loop') && hasMultiplePages;
            var autoplay = getBool($carousel, 'data-autoplay') && hasMultiplePages;
            var autoplayDelay = getInt($carousel, 'data-autoplay-delay', 4500);

            syncCarouselWidth($carousel);

            $carousel.owlCarousel({
                margin: gap,
                items: desktopItems,
                slideBy: getSlideBy($carousel),
                loop: loop,
                autoplay: autoplay,
                autoplayTimeout: autoplayDelay,
                autoplayHoverPause: true,
                smartSpeed: 500,
                nav: arrows && hasMultiplePages,
                dots: dots && hasMultiplePages,
                navText: getNavText(),
                responsive: {
                    0: { items: mobileItems },
                    768: { items: tabletItems },
                    1200: { items: desktopItems },
                },
            });

            $carousel.data('ddOwlCarousel', true);
            cleanDuplicateControls($carousel);

            window.requestAnimationFrame(function () {
                refreshCarousel($carousel);
            });
        });
    }

    function initSingleSlideCarousel(selector) {
        if (!$.fn.owlCarousel) {
            return;
        }

        $(selector).each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                return;
            }

            var slideCount = getInt($carousel, 'data-slide-count', 0);
            var hasMultipleSlides = slideCount > 1;
            var arrows = getBool($carousel, 'data-arrows');
            var dots = getBool($carousel, 'data-dots');
            var loop = getBool($carousel, 'data-loop') && hasMultipleSlides;
            var autoplay = getBool($carousel, 'data-autoplay') && hasMultipleSlides;
            var autoplayDelay = getInt($carousel, 'data-autoplay-delay', 4500);

            syncCarouselWidth($carousel);

            $carousel.owlCarousel({
                items: 1,
                margin: 0,
                loop: loop,
                autoplay: autoplay,
                autoplayTimeout: autoplayDelay,
                autoplayHoverPause: true,
                smartSpeed: 500,
                nav: arrows && hasMultipleSlides,
                dots: dots && hasMultipleSlides,
                navText: getNavText(),
            });

            $carousel.data('ddOwlCarousel', true);
            cleanDuplicateControls($carousel);

            window.requestAnimationFrame(function () {
                refreshCarousel($carousel);
            });
        });
    }

    function refreshCarousels() {
        $('.gallery-slider.owl-carousel, .block-cpt-slider.owl-carousel, .taxonomy-posts-slider.owl-carousel, .logos-slider.owl-carousel, .grid-card-slider.owl-carousel, .text-image-slider.owl-carousel').each(function () {
            var $carousel = $(this);

            if ($carousel.data('ddOwlCarousel')) {
                refreshCarousel($carousel);
            }
        });
    }

    function debounce(callback, delay) {
        var timer = null;

        return function () {
            window.clearTimeout(timer);
            timer = window.setTimeout(callback, delay);
        };
    }

    function initLightboxes() {
        if (!$.fn.lightGallery) {
            return;
        }

        $('.gallery-lightbox').each(function () {
            var $gallery = $(this);

            if ($gallery.data('ddLightGallery')) {
                return;
            }

            $gallery.lightGallery({
                selector: '.gallery-lightbox-item',
                share: true,
                download: true,
                rotate: false,
                showThumbByDefault: true,
                loop: false,
                thumbnail: true,
                exThumbImage: 'data-exthumbimage',
                allowMediaOverlap: true,
                toggleThumb: true,
            });

            $gallery.data('ddLightGallery', true);
        });
    }

    function initServicesSwitchers() {
        $('.services-switcher').each(function () {
            var $switcher = $(this);

            if ($switcher.data('ddServicesSwitcher')) {
                return;
            }

            var $tabs = $switcher.find('.services-switcher-tab');
            var $panels = $switcher.find('.services-switcher-panel');
            var autoplayDelay = getInt($switcher, 'data-switcher-interval', 4500);
            var autoplayTimer = null;

            function activateService(index, focusTab) {
                var $activeTab = $tabs.filter('[data-service-index="' + index + '"]');
                var theme = $activeTab.attr('data-service-theme') || 'blue';

                if (!$activeTab.length) {
                    return;
                }

                $switcher.attr('data-active-theme', theme);

                $tabs
                    .removeClass('is-active')
                    .attr('aria-selected', 'false')
                    .attr('tabindex', '-1');

                $activeTab
                    .addClass('is-active')
                    .attr('aria-selected', 'true')
                    .attr('tabindex', '0');

                $panels
                    .removeClass('is-active')
                    .attr('aria-hidden', 'true');

                $panels
                    .filter('[data-service-index="' + index + '"]')
                    .addClass('is-active')
                    .attr('aria-hidden', 'false');

                if (focusTab) {
                    $activeTab.trigger('focus');
                }
            }

            function startAutoplay() {
                if ($tabs.length < 2) {
                    return;
                }

                window.clearInterval(autoplayTimer);

                autoplayTimer = window.setInterval(function () {
                    var currentPosition = $tabs.index($tabs.filter('.is-active').first());
                    var nextPosition = ((currentPosition < 0 ? 0 : currentPosition) + 1) % $tabs.length;

                    activateService($tabs.eq(nextPosition).attr('data-service-index'), false);
                }, autoplayDelay);
            }

            $tabs.on('click', function () {
                activateService($(this).attr('data-service-index'), false);
                startAutoplay();
            });

            $tabs.on('keydown', function (event) {
                var keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
                var currentIndex = $tabs.index(this);
                var nextIndex = currentIndex;

                if (keys.indexOf(event.key) === -1) {
                    return;
                }

                event.preventDefault();

                if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
                    nextIndex = (currentIndex + 1) % $tabs.length;
                } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
                    nextIndex = (currentIndex - 1 + $tabs.length) % $tabs.length;
                } else if (event.key === 'Home') {
                    nextIndex = 0;
                } else if (event.key === 'End') {
                    nextIndex = $tabs.length - 1;
                }

                activateService($tabs.eq(nextIndex).attr('data-service-index'), true);
                startAutoplay();
            });

            $switcher.data('ddServicesSwitcher', true);
            startAutoplay();
        });
    }

    $(function () {
        initLightboxes();
        initServicesSwitchers();

        initCarousel('.gallery-slider.owl-carousel', {
            countAttribute: 'data-image-count',
            desktopItems: 1,
            tabletItems: 1,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.block-cpt-slider.owl-carousel', {
            countAttribute: 'data-post-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.taxonomy-posts-slider.owl-carousel', {
            countAttribute: 'data-post-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initCarousel('.logos-slider.owl-carousel', {
            countAttribute: 'data-logo-count',
            desktopItems: 4,
            tabletItems: 3,
            mobileItems: 2,
            gap: 24,
        });

        initCarousel('.grid-card-slider.owl-carousel', {
            countAttribute: 'data-card-count',
            desktopItems: 3,
            tabletItems: 2,
            mobileItems: 1,
            gap: 24,
        });

        initSingleSlideCarousel('.text-image-slider.owl-carousel');

        $(window).on('load', refreshCarousels);
        $(window).on('resize orientationchange', debounce(refreshCarousels, 150));
    });
})(jQuery);
